import { IState } from 'app/cross-cutting-concerns/state-management/interfaces/IState';
import { SiteWithOperatingTime } from 'app/modules/site-management/interfaces/Site.types';
import { SiteOperatingTimePeriod } from 'app/cross-cutting-concerns/communication/interfaces/am-api-graphql';
import { Optional } from 'lib/types/Optional';

export class SiteWidgetsFleetDashboardSelectors {
  public static selectData = (state: IState): Optional<SiteWithOperatingTime[]> =>
    state.modules['site-management'].widgets['fleet-dashboard'].data;

  public static selectNoSiteMachinesOperatingTime = (state: IState): Optional<SiteOperatingTimePeriod> =>
    state.modules['site-management'].widgets['fleet-dashboard'].noSiteMachinesOperatingTime;

  public static selectIsLoading = (state: IState): Optional<boolean> =>
    state.modules['site-management'].widgets['fleet-dashboard'].isLoading;

  public static selectPeriodStartDate = (state: IState): Optional<string> =>
    state.modules['site-management'].widgets['fleet-dashboard'].filters.period.startDate;

  public static selectPeriodEndDate = (state: IState): Optional<string> =>
    state.modules['site-management'].widgets['fleet-dashboard'].filters.period.endDate;
}
